// import React from "react";

// const features = [
//   {
//     icon: "1.png",
//     title: "Multi-Persona Debates",
//     desc: "Deploy analytical, tactical, structural, and contrarian AI personas that challenge your problem from every expert angle.",
//   },
//   {
//     icon: "2.png",
//     title: "Structured Rounds",
//     desc: "Each debate round systematically uncovers deeper issues, surfaces hidden tensions, and sharpens recommendations.",
//   },
//   {
//     icon: "3.png",
//     title: "Super Persona Oversight",
//     desc: "One AI layer synthesizes all debate outputs into a single coherent answer, removing contradiction and noise.",
//   },
//   {
//     icon: "4.png",
//     title: "Human Moderator",
//     desc: "Every debate is guided by human oversight ensuring ethical integrity, contextual relevance, and quality control.",
//   },
//   {
//     icon: "5.png",
//     title: "User-Guided Inputs",
//     desc: "You control the debate depth, persona parameters, and creative direction, tailoring every session to your context.",
//   },
//   {
//     icon: "6.png",
//     title: "Iterative Memory",
//     desc: "Omnix remembers prior debates and learns from your feedback, building contextual intelligence over time.",
//   },
// ];

// const Section3 = ({url}) => {
//   return (
//     <section className="home-section-3">
//       <div className="container">

//         {/* Heading */}
//         <div className="section-header text-center">
//           <h2>
//             Built to <span>Think</span> Deeper, <span>Decide</span> Smarter
//           </h2>
//           <p>
//            How our AI persona-based multi-agent debate platform turns your complex problems into clear decisions
//           </p>
//         </div>

//         {/* Features */}
//         <div className="row d-flex justify-content-center align-items-center section-content">
//             <div className="col-10 p-0 m-0">
//                 <div className="row p-0 m-0 features-row">
//                     {features.map((item, index) => (
//                         <div className="col-lg-4 col-md-6" key={index}>
//                         <div className="feature-item">

//                             <div className="icon-box">
//                             <img 
//                             src={`${url}images/omnix/sec-3-icons/${item.icon}`}
//                             alt="" />
//                             </div>

//                             <div className="content">
//                             <h5>{item.title}</h5>
//                             <p>{item.desc}</p>
//                             </div>

//                         </div>
//                         </div>
//                     ))}
//                 </div>                    
//             </div>
//         </div>

//       </div>
//     </section>
//   );
// };

// export default Section3;




import React, { useState } from "react";

const features = [
  { icon: "1.png", title: "Multi-Persona Debates", desc: "Deploy analytical, tactical, structural, and contrarian AI personas that challenge your problem from every expert angle." },
  { icon: "2.png", title: "Structured Rounds", desc: "Each debate round systematically uncovers deeper issues, surfaces hidden tensions, and sharpens recommendations." },
  { icon: "3.png", title: "Super Persona Oversight", desc: "One AI layer synthesizes all debate outputs into a single coherent answer, removing contradiction and noise." },
  { icon: "4.png", title: "Human Moderator", desc: "Every debate is guided by human oversight ensuring ethical integrity, contextual relevance, and quality control." },
  { icon: "5.png", title: "User-Guided Inputs", desc: "You control the debate depth, persona parameters, and creative direction, tailoring every session to your context." },
  { icon: "6.png", title: "Iterative Memory", desc: "Omnix remembers prior debates and learns from your feedback, building contextual intelligence over time." },
];

const Section3 = ({ url }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="home-section-3">
      <div className="container">

        {/* Heading */}
        <div className="section-header text-center">
          <h2>
            Built to <span>Think</span> Deeper, <span>Decide</span> Smarter
          </h2>
          <p>
            How our AI persona-based multi-agent debate platform turns your complex problems into clear decisions
          </p>
        </div>

        {/* DESKTOP VIEW */}
        <div className="row d-flex justify-content-center section-content desktop-view overflow-hidden">
          <div className="col-11 col-xl-10" data-aos="zoom-in"
          data-aos-duration="1000">
            <div className="row features-row">
              {features.map((item, index) => (
                <div className="col-lg-4 col-md-6" key={index}>
                  <div className="feature-item">
                    <div className="icon-box">
                      <img src={`${url}images/omnix/sec-3-icons/${item.icon}`} alt="" />
                    </div>
                    <div className="content">
                      <h5>{item.title}</h5>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* MOBILE TAB VIEW */}
        <div className="mobile-view">

          {/* Tabs */}
          <div className="tabs">
            {features.map((item, index) => (
              <div
                key={index}
                className={`tab-icon ${activeIndex === index ? "active" : ""}`}
                onClick={() => setActiveIndex(index)}
              >
                <img src={`${url}images/omnix/sec-3-icons/${item.icon}`} alt="" />
              </div>
            ))}
          </div>

          {/* Active Content */}
          <div className="tab-content">
            <h5>{features[activeIndex].title}</h5>
            <p>{features[activeIndex].desc}</p>
          </div>

        </div>

      </div>
    </section>
  );
};

export default Section3;